// Librairies
import { ChangeDetectionStrategy, Component } from '@angular/core';

// The buttons of a page header (add, refresh, filter…) grouped in a frosted pill.
@Component({
  selector: 'lib-action-group',
  standalone: true,
  templateUrl: './action-group.component.html',
  styleUrl: './action-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ActionGroupComponent { }
